import { render, staticRenderFns } from "./PolizasSGResponse.vue?vue&type=template&id=88834a2c&scoped=true&"
import script from "./PolizasSGResponse.vue?vue&type=script&lang=js&"
export * from "./PolizasSGResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88834a2c",
  null
  
)

export default component.exports